var _rect, _rect2, _rect3, _g, _path, _rect4, _rect5, _g2, _path2, _rect6, _rect7, _g3, _path3, _path4, _path5, _rect8, _rect9, _g4, _path6, _rect10, _rect11, _g5, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOmbreSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 526,
    height: 86,
    viewBox: "0 0 526 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 526,
    height: 86,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 11,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#114878"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12815_2346",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 11,
    width: 64,
    height: 64
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 11,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#0B84EE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12815_2346)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 11,
    width: 64,
    height: 57,
    rx: 14,
    fill: "#1877F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.7188 40.9235H87.4155L88.3099 35.1014H81.7177V31.9193C81.7177 29.5006 82.5032 27.3559 84.752 27.3559H88.3655V22.2751C87.7306 22.1888 86.3878 22 83.8506 22C78.5525 22 75.4464 24.8149 75.4464 31.2281V35.1014H70V40.9235H75.4464V56.9261C76.525 57.0893 77.6175 57.2 78.739 57.2C79.7528 57.2 80.7422 57.1068 81.7188 56.9739V40.9235Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 11,
    width: 64,
    height: 64,
    rx: 16,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_12815_2346",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 11,
    width: 64,
    height: 64
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 11,
    width: 64,
    height: 64,
    rx: 16,
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_12815_2346)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 11,
    width: 64,
    height: 57,
    rx: 14,
    fill: "#353535"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.14 37.1886L184.861 25H182.321L173.011 35.5832L165.576 25H157L168.244 41.0036L157 53.7852H159.541L169.372 42.609L177.224 53.7852H185.8L174.139 37.1886H174.14ZM170.66 41.1446L169.521 39.551L160.456 26.8706H164.359L171.674 37.1041L172.813 38.6977L182.322 51.9997H178.419L170.66 41.1452V41.1446Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 11,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#7D1B64"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_12815_2346",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 231,
    y: 11,
    width: 64,
    height: 64
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 11,
    width: 64,
    height: 64,
    rx: 16,
    fill: "url(#paint0_radial_12815_2346)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_12815_2346)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 11,
    width: 64,
    height: 57,
    rx: 14,
    fill: "url(#paint1_radial_12815_2346)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M263 25.8916C267.241 25.8916 267.819 25.8916 269.554 25.8916C271.096 25.8916 271.867 26.2771 272.446 26.4699C273.217 26.8554 273.795 27.0482 274.373 27.6265C274.952 28.2048 275.337 28.7831 275.53 29.5542C275.723 30.1325 275.916 30.9036 276.108 32.4458C276.108 34.1807 276.108 34.5663 276.108 39C276.108 43.4337 276.108 43.8193 276.108 45.5542C276.108 47.0964 275.723 47.8675 275.53 48.4458C275.145 49.2169 274.952 49.7952 274.373 50.3735C273.795 50.9518 273.217 51.3374 272.446 51.5301C271.867 51.7229 271.096 51.9157 269.554 52.1084C267.819 52.1084 267.434 52.1084 263 52.1084C258.566 52.1084 258.181 52.1084 256.446 52.1084C254.904 52.1084 254.133 51.7229 253.554 51.5301C252.783 51.1446 252.205 50.9518 251.627 50.3735C251.048 49.7952 250.663 49.2169 250.47 48.4458C250.277 47.8675 250.084 47.0964 249.892 45.5542C249.892 43.8193 249.892 43.4337 249.892 39C249.892 34.5663 249.892 34.1807 249.892 32.4458C249.892 30.9036 250.277 30.1325 250.47 29.5542C250.855 28.7831 251.048 28.2048 251.627 27.6265C252.205 27.0482 252.783 26.6627 253.554 26.4699C254.133 26.2771 254.904 26.0843 256.446 25.8916C258.181 25.8916 258.759 25.8916 263 25.8916ZM263 23C258.566 23 258.181 23 256.446 23C254.711 23 253.554 23.3855 252.59 23.7711C251.627 24.1566 250.663 24.7349 249.699 25.6988C248.735 26.6627 248.349 27.4337 247.771 28.5904C247.386 29.5542 247.193 30.7108 247 32.4458C247 34.1807 247 34.759 247 39C247 43.4337 247 43.8193 247 45.5542C247 47.2892 247.386 48.4458 247.771 49.4096C248.157 50.3735 248.735 51.3374 249.699 52.3012C250.663 53.2651 251.434 53.6506 252.59 54.2289C253.554 54.6145 254.711 54.8072 256.446 55C258.181 55 258.759 55 263 55C267.241 55 267.819 55 269.554 55C271.289 55 272.446 54.6145 273.41 54.2289C274.373 53.8434 275.337 53.2651 276.301 52.3012C277.265 51.3374 277.651 50.5663 278.229 49.4096C278.614 48.4458 278.807 47.2892 279 45.5542C279 43.8193 279 43.241 279 39C279 34.759 279 34.1807 279 32.4458C279 30.7108 278.614 29.5542 278.229 28.5904C277.843 27.6265 277.265 26.6627 276.301 25.6988C275.337 24.7349 274.566 24.3494 273.41 23.7711C272.446 23.3855 271.289 23.1928 269.554 23C267.819 23 267.434 23 263 23Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M263 30.7108C258.373 30.7108 254.711 34.3735 254.711 39C254.711 43.6265 258.373 47.2892 263 47.2892C267.627 47.2892 271.289 43.6265 271.289 39C271.289 34.3735 267.627 30.7108 263 30.7108ZM263 44.3976C260.108 44.3976 257.602 42.0843 257.602 39C257.602 36.1084 259.916 33.6024 263 33.6024C265.892 33.6024 268.398 35.9157 268.398 39C268.398 41.8916 265.892 44.3976 263 44.3976Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M271.482 32.4458C272.547 32.4458 273.41 31.5827 273.41 30.5181C273.41 29.4534 272.547 28.5904 271.482 28.5904C270.417 28.5904 269.554 29.4534 269.554 30.5181C269.554 31.5827 270.417 32.4458 271.482 32.4458Z",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 11,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#114975"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_12815_2346",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 323,
    y: 11,
    width: 64,
    height: 64
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 11,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#004467"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_12815_2346)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 11,
    width: 64,
    height: 57,
    rx: 14,
    fill: "#2878B7"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M370.199 42.7891V53.3791H364V43.4348C364 40.981 363.096 39.3021 360.901 39.3021C359.222 39.3021 358.189 40.4644 357.801 41.4976C357.672 41.885 357.543 42.4016 357.543 43.0474V53.3791H351.344C351.344 53.3791 351.473 36.59 351.344 34.9111H357.543V37.4941C358.318 36.2026 359.868 34.3945 363.096 34.3945C367.1 34.3945 370.199 37.1066 370.199 42.7891ZM344.886 26C342.82 26 341.399 27.4206 341.399 29.2287C341.399 31.0367 342.691 32.4573 344.757 32.4573C346.953 32.4573 348.244 31.0367 348.244 29.2287C348.373 27.2915 347.082 26 344.886 26ZM341.787 53.3791H347.986V34.9111H341.787V53.3791Z",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 11,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#74160E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_12815_2346",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 415,
    y: 11,
    width: 64,
    height: 64
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 11,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#74160E"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_12815_2346)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 11,
    width: 64,
    height: 57,
    rx: 14,
    fill: "#F40000"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.02 50.2909C432.393 50.1052 431.82 49.7749 431.351 49.3278C430.881 48.8807 430.529 48.3299 430.324 47.722C429.149 44.5798 428.801 31.4591 431.063 28.8689C431.816 28.0263 432.879 27.5075 434.021 27.4252C440.089 26.7883 458.836 26.8732 460.989 27.6375C461.595 27.8293 462.148 28.1524 462.608 28.5826C463.067 29.0128 463.421 29.5389 463.643 30.1215C464.926 33.3699 464.97 45.1743 463.469 48.2952C463.071 49.1076 462.404 49.7657 461.577 50.1635C459.315 51.2675 436.022 51.2463 433.02 50.2909V50.2909ZM442.655 44.1339L453.53 38.6139L442.655 33.0514V44.1339Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12815_2346",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.287 12.3) scale(147.795)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ED32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EE2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D22A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8B2AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#1B2AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#002AFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_12815_2346",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.287 12.1578) scale(147.795 131.63)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ED32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EE2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D22A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8B2AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#1B2AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#002AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmbreSocial);
export default __webpack_public_path__ + "static/media/OmbreSocial.0ebc2325a8eb1caa1153b247b185b3d3.svg";
export { ForwardRef as ReactComponent };